import { render } from "./ScheduledInvoices.vue?vue&type=template&id=39585970&ts=true"
import script from "./ScheduledInvoices.vue?vue&type=script&lang=ts"
export * from "./ScheduledInvoices.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__